import type { HttpEvent, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { EMPTY, Observable, catchError } from "rxjs";
import { Response } from "../interfaces/response.interface";

import { LoaderService } from "../services/loader.service";
import { MessageService } from "../services/message.service";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((response) => {
      const errorResponse = response.error as Response<any>;

      if (errorResponse?.errors) {
        let errors: string | string[] = "Wystąpił nieznany błąd";

        if (errorResponse?.errors?.length) {
          const errorList = errorResponse.errors.map((error) =>
            error.userMessage === "Unhandled exception"
              ? "Wystąpił nieznany błąd"
              : error.userMessage,
          ).filter((errorMessage) => !!errorMessage);

          if (errorList.length) errors = errorList as string[];
        }

        switch (response.status) {
          case 304:
            break;

          default:
            messageService.show("error", errors);
            loaderService.hide();
            return EMPTY;
        }
      }

      if (!response.ok) {
        messageService.show("error", "Wystąpił nieznany błąd");
        loaderService.hide();
      }

      return response;
    }),
  ) as Observable<HttpEvent<unknown>>;
};
